/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.mat-expansion-panel-header{padding:0 10px!important;height:auto!important;min-height:48px!important}.sideBarMenu--title{font-size:20px;color:#333;font-weight:600;margin-bottom:20px}.submenu{padding-left:2px;padding-bottom:10px;padding-top:0}.submenu a{cursor:pointer}.defaultColor{color:#333}.content_description{padding-bottom:20px;display:block}\n'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3NoYWl6YXIvUHJvamVjdHMvTUFNUFUvTXlHb3YvcG9ydGFsLWZlL3NyYy9hcHAvYXJ0aWNsZS9sZWZ0bWVudS9sZWZ0bWVudS5jb21wb25lbnQuY3NzLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9zaGFpemFyL1Byb2plY3RzL01BTVBVL015R292L3BvcnRhbC1mZS9zcmMvYXBwL2FydGljbGUvbGVmdG1lbnUvbGVmdG1lbnUuY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/article/leftmenu/leftmenu.component.css.ngstyle.ts